// Dependencies
import React from "react";

// Material UI Components
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// Helpers

// Styles
import { useStyles } from "./EvergreenFilterOption.styles";

const EvergreenFilterOption = ({ options, label, largeForm, ...props }) => {
  const classes = useStyles();
  return (
    <Select className={classes.customSelect} displayEmpty {...props}>
      <MenuItem key={label} value={0} className={classes.placeholder}>
        {label}
      </MenuItem>
      {options.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default EvergreenFilterOption;
